__turbopack_context__.v({
  "a": "styles-module__AWEYvG__a",
  "b": "styles-module__AWEYvG__b",
  "c": "styles-module__AWEYvG__c",
  "pattern": "styles-module__AWEYvG__pattern",
});
